/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ConsentRouteImport } from './routes/consent'
import { Route as ConsentedRouteImport } from './routes/_consented'
import { Route as ConsentIndexRouteImport } from './routes/consent.index'
import { Route as ConsentedIndexRouteImport } from './routes/_consented/index'
import { Route as ConsentSignRouteImport } from './routes/consent.sign'
import { Route as ConsentedQuestionnairesRouteImport } from './routes/_consented/questionnaires'
import { Route as ConsentedProfileRouteImport } from './routes/_consented/profile'
import { Route as ConsentedConsentFormsRouteImport } from './routes/_consented/consent-forms'
import { Route as ConsentedAppointmentsRouteImport } from './routes/_consented/appointments'
import { Route as ConsentedDocumentsIndexRouteImport } from './routes/_consented/documents.index'
import { Route as ConsentedWaitingRoomVisitIdRouteImport } from './routes/_consented/waiting-room.$visitId'
import { Route as ConsentedQuestionnairesIdRouteImport } from './routes/_consented/questionnaires_.$id'
import { Route as ConsentedDocumentsDocumentIdRouteImport } from './routes/_consented/documents.$documentId'
import { Route as ConsentedConsentFormsKeyRouteImport } from './routes/_consented/consent-forms_.$key'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ConsentRoute = ConsentRouteImport.update({
  id: '/consent',
  path: '/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const ConsentedRoute = ConsentedRouteImport.update({
  id: '/_consented',
  getParentRoute: () => rootRouteImport,
} as any)
const ConsentIndexRoute = ConsentIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ConsentRoute,
} as any)
const ConsentedIndexRoute = ConsentedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ConsentedRoute,
} as any)
const ConsentSignRoute = ConsentSignRouteImport.update({
  id: '/sign',
  path: '/sign',
  getParentRoute: () => ConsentRoute,
} as any)
const ConsentedQuestionnairesRoute = ConsentedQuestionnairesRouteImport.update({
  id: '/questionnaires',
  path: '/questionnaires',
  getParentRoute: () => ConsentedRoute,
} as any)
const ConsentedProfileRoute = ConsentedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => ConsentedRoute,
} as any)
const ConsentedConsentFormsRoute = ConsentedConsentFormsRouteImport.update({
  id: '/consent-forms',
  path: '/consent-forms',
  getParentRoute: () => ConsentedRoute,
} as any)
const ConsentedAppointmentsRoute = ConsentedAppointmentsRouteImport.update({
  id: '/appointments',
  path: '/appointments',
  getParentRoute: () => ConsentedRoute,
} as any)
const ConsentedDocumentsIndexRoute = ConsentedDocumentsIndexRouteImport.update({
  id: '/documents/',
  path: '/documents/',
  getParentRoute: () => ConsentedRoute,
} as any)
const ConsentedWaitingRoomVisitIdRoute =
  ConsentedWaitingRoomVisitIdRouteImport.update({
    id: '/waiting-room/$visitId',
    path: '/waiting-room/$visitId',
    getParentRoute: () => ConsentedRoute,
  } as any)
const ConsentedQuestionnairesIdRoute =
  ConsentedQuestionnairesIdRouteImport.update({
    id: '/questionnaires_/$id',
    path: '/questionnaires/$id',
    getParentRoute: () => ConsentedRoute,
  } as any)
const ConsentedDocumentsDocumentIdRoute =
  ConsentedDocumentsDocumentIdRouteImport.update({
    id: '/documents/$documentId',
    path: '/documents/$documentId',
    getParentRoute: () => ConsentedRoute,
  } as any)
const ConsentedConsentFormsKeyRoute =
  ConsentedConsentFormsKeyRouteImport.update({
    id: '/consent-forms_/$key',
    path: '/consent-forms/$key',
    getParentRoute: () => ConsentedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof ConsentedIndexRoute
  '/consent': typeof ConsentRouteWithChildren
  '/login': typeof LoginRoute
  '/appointments': typeof ConsentedAppointmentsRoute
  '/consent-forms': typeof ConsentedConsentFormsRoute
  '/profile': typeof ConsentedProfileRoute
  '/questionnaires': typeof ConsentedQuestionnairesRoute
  '/consent/sign': typeof ConsentSignRoute
  '/consent/': typeof ConsentIndexRoute
  '/consent-forms/$key': typeof ConsentedConsentFormsKeyRoute
  '/documents/$documentId': typeof ConsentedDocumentsDocumentIdRoute
  '/questionnaires/$id': typeof ConsentedQuestionnairesIdRoute
  '/waiting-room/$visitId': typeof ConsentedWaitingRoomVisitIdRoute
  '/documents/': typeof ConsentedDocumentsIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/appointments': typeof ConsentedAppointmentsRoute
  '/consent-forms': typeof ConsentedConsentFormsRoute
  '/profile': typeof ConsentedProfileRoute
  '/questionnaires': typeof ConsentedQuestionnairesRoute
  '/consent/sign': typeof ConsentSignRoute
  '/': typeof ConsentedIndexRoute
  '/consent': typeof ConsentIndexRoute
  '/consent-forms/$key': typeof ConsentedConsentFormsKeyRoute
  '/documents/$documentId': typeof ConsentedDocumentsDocumentIdRoute
  '/questionnaires/$id': typeof ConsentedQuestionnairesIdRoute
  '/waiting-room/$visitId': typeof ConsentedWaitingRoomVisitIdRoute
  '/documents': typeof ConsentedDocumentsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_consented': typeof ConsentedRouteWithChildren
  '/consent': typeof ConsentRouteWithChildren
  '/login': typeof LoginRoute
  '/_consented/appointments': typeof ConsentedAppointmentsRoute
  '/_consented/consent-forms': typeof ConsentedConsentFormsRoute
  '/_consented/profile': typeof ConsentedProfileRoute
  '/_consented/questionnaires': typeof ConsentedQuestionnairesRoute
  '/consent/sign': typeof ConsentSignRoute
  '/_consented/': typeof ConsentedIndexRoute
  '/consent/': typeof ConsentIndexRoute
  '/_consented/consent-forms_/$key': typeof ConsentedConsentFormsKeyRoute
  '/_consented/documents/$documentId': typeof ConsentedDocumentsDocumentIdRoute
  '/_consented/questionnaires_/$id': typeof ConsentedQuestionnairesIdRoute
  '/_consented/waiting-room/$visitId': typeof ConsentedWaitingRoomVisitIdRoute
  '/_consented/documents/': typeof ConsentedDocumentsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/consent'
    | '/login'
    | '/appointments'
    | '/consent-forms'
    | '/profile'
    | '/questionnaires'
    | '/consent/sign'
    | '/consent/'
    | '/consent-forms/$key'
    | '/documents/$documentId'
    | '/questionnaires/$id'
    | '/waiting-room/$visitId'
    | '/documents/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/appointments'
    | '/consent-forms'
    | '/profile'
    | '/questionnaires'
    | '/consent/sign'
    | '/'
    | '/consent'
    | '/consent-forms/$key'
    | '/documents/$documentId'
    | '/questionnaires/$id'
    | '/waiting-room/$visitId'
    | '/documents'
  id:
    | '__root__'
    | '/_consented'
    | '/consent'
    | '/login'
    | '/_consented/appointments'
    | '/_consented/consent-forms'
    | '/_consented/profile'
    | '/_consented/questionnaires'
    | '/consent/sign'
    | '/_consented/'
    | '/consent/'
    | '/_consented/consent-forms_/$key'
    | '/_consented/documents/$documentId'
    | '/_consented/questionnaires_/$id'
    | '/_consented/waiting-room/$visitId'
    | '/_consented/documents/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ConsentedRoute: typeof ConsentedRouteWithChildren
  ConsentRoute: typeof ConsentRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/consent': {
      id: '/consent'
      path: '/consent'
      fullPath: '/consent'
      preLoaderRoute: typeof ConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_consented': {
      id: '/_consented'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ConsentedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/consent/': {
      id: '/consent/'
      path: '/'
      fullPath: '/consent/'
      preLoaderRoute: typeof ConsentIndexRouteImport
      parentRoute: typeof ConsentRoute
    }
    '/_consented/': {
      id: '/_consented/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ConsentedIndexRouteImport
      parentRoute: typeof ConsentedRoute
    }
    '/consent/sign': {
      id: '/consent/sign'
      path: '/sign'
      fullPath: '/consent/sign'
      preLoaderRoute: typeof ConsentSignRouteImport
      parentRoute: typeof ConsentRoute
    }
    '/_consented/questionnaires': {
      id: '/_consented/questionnaires'
      path: '/questionnaires'
      fullPath: '/questionnaires'
      preLoaderRoute: typeof ConsentedQuestionnairesRouteImport
      parentRoute: typeof ConsentedRoute
    }
    '/_consented/profile': {
      id: '/_consented/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ConsentedProfileRouteImport
      parentRoute: typeof ConsentedRoute
    }
    '/_consented/consent-forms': {
      id: '/_consented/consent-forms'
      path: '/consent-forms'
      fullPath: '/consent-forms'
      preLoaderRoute: typeof ConsentedConsentFormsRouteImport
      parentRoute: typeof ConsentedRoute
    }
    '/_consented/appointments': {
      id: '/_consented/appointments'
      path: '/appointments'
      fullPath: '/appointments'
      preLoaderRoute: typeof ConsentedAppointmentsRouteImport
      parentRoute: typeof ConsentedRoute
    }
    '/_consented/documents/': {
      id: '/_consented/documents/'
      path: '/documents'
      fullPath: '/documents/'
      preLoaderRoute: typeof ConsentedDocumentsIndexRouteImport
      parentRoute: typeof ConsentedRoute
    }
    '/_consented/waiting-room/$visitId': {
      id: '/_consented/waiting-room/$visitId'
      path: '/waiting-room/$visitId'
      fullPath: '/waiting-room/$visitId'
      preLoaderRoute: typeof ConsentedWaitingRoomVisitIdRouteImport
      parentRoute: typeof ConsentedRoute
    }
    '/_consented/questionnaires_/$id': {
      id: '/_consented/questionnaires_/$id'
      path: '/questionnaires/$id'
      fullPath: '/questionnaires/$id'
      preLoaderRoute: typeof ConsentedQuestionnairesIdRouteImport
      parentRoute: typeof ConsentedRoute
    }
    '/_consented/documents/$documentId': {
      id: '/_consented/documents/$documentId'
      path: '/documents/$documentId'
      fullPath: '/documents/$documentId'
      preLoaderRoute: typeof ConsentedDocumentsDocumentIdRouteImport
      parentRoute: typeof ConsentedRoute
    }
    '/_consented/consent-forms_/$key': {
      id: '/_consented/consent-forms_/$key'
      path: '/consent-forms/$key'
      fullPath: '/consent-forms/$key'
      preLoaderRoute: typeof ConsentedConsentFormsKeyRouteImport
      parentRoute: typeof ConsentedRoute
    }
  }
}

interface ConsentedRouteChildren {
  ConsentedAppointmentsRoute: typeof ConsentedAppointmentsRoute
  ConsentedConsentFormsRoute: typeof ConsentedConsentFormsRoute
  ConsentedProfileRoute: typeof ConsentedProfileRoute
  ConsentedQuestionnairesRoute: typeof ConsentedQuestionnairesRoute
  ConsentedIndexRoute: typeof ConsentedIndexRoute
  ConsentedConsentFormsKeyRoute: typeof ConsentedConsentFormsKeyRoute
  ConsentedDocumentsDocumentIdRoute: typeof ConsentedDocumentsDocumentIdRoute
  ConsentedQuestionnairesIdRoute: typeof ConsentedQuestionnairesIdRoute
  ConsentedWaitingRoomVisitIdRoute: typeof ConsentedWaitingRoomVisitIdRoute
  ConsentedDocumentsIndexRoute: typeof ConsentedDocumentsIndexRoute
}

const ConsentedRouteChildren: ConsentedRouteChildren = {
  ConsentedAppointmentsRoute: ConsentedAppointmentsRoute,
  ConsentedConsentFormsRoute: ConsentedConsentFormsRoute,
  ConsentedProfileRoute: ConsentedProfileRoute,
  ConsentedQuestionnairesRoute: ConsentedQuestionnairesRoute,
  ConsentedIndexRoute: ConsentedIndexRoute,
  ConsentedConsentFormsKeyRoute: ConsentedConsentFormsKeyRoute,
  ConsentedDocumentsDocumentIdRoute: ConsentedDocumentsDocumentIdRoute,
  ConsentedQuestionnairesIdRoute: ConsentedQuestionnairesIdRoute,
  ConsentedWaitingRoomVisitIdRoute: ConsentedWaitingRoomVisitIdRoute,
  ConsentedDocumentsIndexRoute: ConsentedDocumentsIndexRoute,
}

const ConsentedRouteWithChildren = ConsentedRoute._addFileChildren(
  ConsentedRouteChildren,
)

interface ConsentRouteChildren {
  ConsentSignRoute: typeof ConsentSignRoute
  ConsentIndexRoute: typeof ConsentIndexRoute
}

const ConsentRouteChildren: ConsentRouteChildren = {
  ConsentSignRoute: ConsentSignRoute,
  ConsentIndexRoute: ConsentIndexRoute,
}

const ConsentRouteWithChildren =
  ConsentRoute._addFileChildren(ConsentRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  ConsentedRoute: ConsentedRouteWithChildren,
  ConsentRoute: ConsentRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
